import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi, defaultClient } from '@mint-sdk/api-core';

import {
  GroupingBodySchema,
  GroupingRulesResponseDeprecatedSchema,
  GroupingRulesResponseSchema,
} from '../shared/schemas/grouping.js';
import { hasPopulatesRulesResponseSchema } from '../shared/schemas/utm.js';

export const patchGrouping = defaultClient.mutation({
  url: `ga4-service/groupings/$groupingId` as const,
  method: 'PATCH',
  responseSchema: GroupingRulesResponseSchema,
  requestSchema: GroupingBodySchema,
  processResponse(data) {
    return data;
  },
});
export const patchGroupingDeprecated = defaultApi.declareEndpoint({
  url: `ga4-service/groupings/$groupingId` as const,
  method: 'PATCH',
  responseSchema: GroupingRulesResponseDeprecatedSchema,
  requestSchema: GroupingBodySchema,
});

export const patchGroupingQueryOptions = makeQueryOptions(
  patchGroupingDeprecated,
  {
    processResponse(data) {
      return data;
    },
  },
);

// check populated rules to show change filter dialog
export const getHasPopulatesRulesGrouping = defaultApi.declareEndpoint({
  url: `ga4-service/groupings/$groupingId/check-populated-rules` as const,
  method: 'GET',
  responseSchema: hasPopulatesRulesResponseSchema,
});
